'use client';

import { mediaCommonUrls } from '@/constants/common-urls';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { Media } from '@cinemark/content-api-client';

class MediaApiService {
  async getMedia(id: string, signal?: AbortSignal): Promise<CommonFetchResponse<Media>> {
    const response = await commonFetch<Media>(`${mediaCommonUrls.mediaPrefix}/${id}`, signal ? { signal } : undefined);
    return response;
  }
}

export const mediaApiService = new MediaApiService();
